<hr/>
<div class="panel panel-primary panel-succes" data-testid="picket-signin-page">
  <div class="panel-heading clearfix">
    <h4 class="panel-title pull-left" style="padding-top: 0px; padding-bottom: 0px" data-testid="picket-signin-header">
      {{ picketName }} Sign-In : {{ currentTime | date: "medium" }}
    </h4>
  </div>
  <div class="panel-body">
    <form class="form-horizontal" role="form">
      <div class="col-md-6 pull-left">
        <div class="row">
          <div class="input-group input-group-sm col-xs-12 col-sm-12 col-md-12">
            <label for="inputSearchMembers" class="control-label">Scan Member Card here ...</label>
            <input id="inputSearchMembers" name="inputId" strikeAutoFocus type="search"
              [(ngModel)]="filterMember" class="form-control shortInputSearch" placeholder="Filter.."
              data-testid="picket-signin-input"/>
            <div class="input-group-btn">
              <button class="btn btn-primary" (click)="searchMbr()" data-testid="picket-signin-search-button">
                <i class="glyphicon glyphicon-search"></i>
              </button>
              <button class="btn btn-primary" (click)="clearSearchMbr()" data-testid="picket-signin-clear-button">
                <i class="glyphicon glyphicon-remove-sign"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12" *ngIf="member.MemberId">
            <!--<br />-->
            <div [hidden]="existingSignIn.LastName">
              <div class="col-xs-6 col-sm-6 alert alert-danger" data-testid="picket-signin-member-info">
                <h4>
                  {{
                  member.LastName +
                  ", " +
                  member.FirstName +
                  " " +
                  member.MiddleName
                  }}
                </h4>
                <div>
                  <span class="control-label">{{ member.Address_1 }}</span>
                  <br />
                  <div *ngIf="member.Address_2">
                    <span class="control-label">{{ member.Address_2 }}</span>
                    <br />
                  </div>
                  <span class="control-label">{{ member.City + " " + member.State + " " + member.Zip }}</span><br />
                  <span class="control-label"><i>{{ "Ph. " + member.Phone }}</i></span>
                </div>
              </div>

              <div class="col-xs-5 col-sm-5 pull-right">
                <div class="row">
                  <div class="alert alert-success">
                    <span class="control-label" style="color: blue">{{ member.StrikeShift }}</span>
                    <br />
                    <span class="control-label" style="color: blue">Picketline: {{ member.StrikeLine }}</span>
                  </div>
                </div>
                <div class="row">
                  <button type="button" style="width: 100%; height: 100%" class="btn btn-success"
                    (click)="addSignInPicketline()" [disabled]="existingSignIn.LastName" data-testid="picket-signin-button">
                    Sign-In
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row alert alert-danger" *ngIf="displayExistingSignInMessage" data-testid="picket-signin-already-signedin">
          <div class="col-xs-12 col-sm-12 col-md-12" style="text-align: center">
            <h4 class="color:red">Already Signed-in !!!</h4>
            <h4>{{ alreadyExistingMessage }}</h4>
            <br />
          </div>
        </div>
        <div class="pull-left">
          <a [routerLink]="['/strikes/', strikeId]" data-testid="picket-signin-back-to-strike">Back to Strike </a>
        </div>
      </div>

      <div class="col-md-6 col-xs-12 pull-right">
        <div class="alert alert-info" style="padding: 0 0 0 10px">
          <span class="control-label">Last Sign-In </span>
        </div>

        <div class="table-responsive" [hidden]="lastSignedInMembers.length <= 0">
          <table class="table table-striped table-condensed">
            <thead>
              <tr>
                <th>SlNo</th>
                <th>SignIn</th>
                <th>ID</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="
                  let signedInMember of lastSignedInMembers | slice: 0 : 4
                ">
                <td data-testid="signin-no">{{ signedInMember.SlNo }}</td>
                <td>{{ signedInMember.SignIn | date: "h:mma" }}</td>
                <td>
                  <div *ngIf="signedInMember.ImageExists">
                    <img class="thumbnail" width="75px" height="50px" src="Content/images/members/{{
                        signedInMember.MemberId
                      }}.jpg" alt="{{ signedInMember.MemberId }}" />
                    <br />
                    {{ signedInMember.MemberId }}
                  </div>
                  <div *ngIf="!signedInMember.ImageExists">
                    {{ signedInMember.MemberId }}
                  </div>
                </td>
                <td [attr.data-testid]="'signin-name-' + signedInMember.MemberId">
                  {{
                  signedInMember.LastName +
                  " " +
                  signedInMember.MiddleName +
                  " " +
                  signedInMember.FirstName
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </form>
  </div>
  <div class="panel-footer clearfix"></div>
</div>
